var map = {
	".": 64,
	"./": 64,
	"./GraphQLLanguageService": 72,
	"./GraphQLLanguageService.d.ts": 407,
	"./GraphQLLanguageService.d.ts.map": 408,
	"./GraphQLLanguageService.js": 72,
	"./GraphQLLanguageService.js.map": 409,
	"./autocompleteUtils": 50,
	"./autocompleteUtils.d.ts": 410,
	"./autocompleteUtils.d.ts.map": 411,
	"./autocompleteUtils.js": 50,
	"./autocompleteUtils.js.map": 412,
	"./getAutocompleteSuggestions": 58,
	"./getAutocompleteSuggestions.d.ts": 413,
	"./getAutocompleteSuggestions.d.ts.map": 414,
	"./getAutocompleteSuggestions.js": 58,
	"./getAutocompleteSuggestions.js.map": 415,
	"./getDefinition": 54,
	"./getDefinition.d.ts": 416,
	"./getDefinition.d.ts.map": 417,
	"./getDefinition.js": 54,
	"./getDefinition.js.map": 418,
	"./getDiagnostics": 59,
	"./getDiagnostics.d.ts": 419,
	"./getDiagnostics.d.ts.map": 420,
	"./getDiagnostics.js": 59,
	"./getDiagnostics.js.map": 421,
	"./getHoverInformation": 65,
	"./getHoverInformation.d.ts": 422,
	"./getHoverInformation.d.ts.map": 423,
	"./getHoverInformation.js": 65,
	"./getHoverInformation.js.map": 424,
	"./getOutline": 71,
	"./getOutline.d.ts": 425,
	"./getOutline.d.ts.map": 426,
	"./getOutline.js": 71,
	"./getOutline.js.map": 427,
	"./index": 64,
	"./index.d.ts": 428,
	"./index.d.ts.map": 429,
	"./index.js": 64,
	"./index.js.map": 430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;